"use client"

import * as React from "react"

import { useLiveScoreTrendSeries } from "@shared/ui/hooks/use-live-chart-series"

const MiniChart = React.lazy(() =>
  import("@shared/ui/landing/mini-chart").then((mod) => ({ default: mod.MiniChart })),
)

export function SecurityScoreChart() {
  const data = useLiveScoreTrendSeries("security-score")

  return (
    <React.Suspense fallback={<div className="h-32 animate-pulse rounded-lg bg-white/5" />}>
      <MiniChart data={data} type="area" color="#38bdf8" />
    </React.Suspense>
  )
}
